import React, { Fragment, memo, useCallback, useEffect, useState } from "react";
import { ORDER_TYPES } from "./orderTypeSelectorConstants.js";
import { Slider } from "../Slider/Slider.jsx";
import {
    OrderTypeSelectorHeaderStyled,
    OrderTypeSelectorListItemStyled,
    OrderTypeSelectorListStyled,
    OrderTypeSelectorStyled,
    OrderTypeSelectorToggleStyled,
    OrderTypeSelectorToggleTitleStyled,
    OrderTypeSelectorToggleValueStyled
} from "./styled/OrderTypeSelectorStyled.js";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import _ from "lodash";

function OrderTypeSelectorToggle(props) {
    const {getLangPath} = useLangContext();

    return <OrderTypeSelectorToggleStyled>
        <OrderTypeSelectorToggleTitleStyled>
            {getLangPath('lite_version.order.order_type')}
        </OrderTypeSelectorToggleTitleStyled>
        <OrderTypeSelectorToggleValueStyled>
            {getLangPath(`lite_version.order.types.${_.toLower(props.selected)}.type`)}
        </OrderTypeSelectorToggleValueStyled>
    </OrderTypeSelectorToggleStyled>
}

function OrderTypeSelector(props) {
    const {
        defaultValue,
        onChange,
    } = props;

    const {getLangPath} = useLangContext();
    const [value, setValue] = useState(defaultValue);

    const setHandler = useCallback((newValue) => {
        if (newValue !== value) {
            setValue(newValue);
            onChange(newValue);
        }
    }, [onChange, value]);

    const onChangeHandler = useCallback((e) => {
        const value = e.currentTarget.dataset.value;
        setHandler(value);
    }, [setHandler]);

    useEffect(() => {
        if (!ORDER_TYPES[value]) {
            setHandler(ORDER_TYPES.MARKET);
        }
    }, [setHandler, value]);

    return <OrderTypeSelectorStyled>
        <Slider showCloseButton={false}
                toggleComponent={<OrderTypeSelectorToggle selected={value}/>}
                placement={'bottom'}>
            <OrderTypeSelectorHeaderStyled>{getLangPath('lite_version.order.order_type')}</OrderTypeSelectorHeaderStyled>
            <OrderTypeSelectorListStyled>
                {
                    Object.keys(ORDER_TYPES).map(item => <Fragment key={item}>
                        <Slider.Row data-value={item} onClick={onChangeHandler}>
                            <OrderTypeSelectorListItemStyled selected={value === item}
                                 data-value={item}
                            >{getLangPath(`lite_version.order.types.${_.toLower(item)}.type`)}</OrderTypeSelectorListItemStyled>
                        </Slider.Row>
                    </Fragment>)
                }
            </OrderTypeSelectorListStyled>
        </Slider>
    </OrderTypeSelectorStyled>
}

export default memo(OrderTypeSelector);
